"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useDividerStyle = ({ type }) => {
    const theme = (0, material_1.useTheme)();
    const dividerStyle = Object.assign(Object.assign({ width: '100%', backgroundColor: theme.qlub.palette.dim.main, height: type === 'medium' ? '2px' : type === 'large' ? '3px' : '1px' }, (type === 'fullWidth'
        ? {
            height: '1px',
            paddingLeft: 'inherit',
            paddingRight: 'inherit',
            position: 'absolute',
            left: 0,
            right: 0,
        }
        : {})), { display: 'flex', justifyContent: 'center', '& p': {
            position: 'relative',
            top: '-10px',
            background: theme.qlub.palette.white.main,
            color: theme.qlub.palette.onSurfaceColors.highEmphasis,
            display: 'block',
            minWidth: '25px',
            padding: '0 12px',
            height: '20px',
            textAlign: 'center',
        } });
    return {
        dividerStyle,
    };
};
exports.default = useDividerStyle;
